import { useState, useCallback } from 'react';

/**
 * Custom hook to handle entitlement validation
 * Mimics the RM.Components.RMEntitlementFinder functionality from the legacy code
 */
export const useEntitlementValidation = () => {
    const [isValidating, setIsValidating] = useState(false);
    const [entitlement, setEntitlement] = useState(null);
    const [error, setError] = useState(null);

    const validateEntitlement = useCallback(async (userOrg) => {
        setIsValidating(true);
        setError(null);

        try {
            // Use the same API call that the legacy RMEntitlementFinder used
            const response = await fetch(`/api/v3/organizations/${userOrg}/entitlements`, {
                method: 'GET',
                headers: {
                    'X-Auth-Token': sessionStorage.getItem('sessionToken'),
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error('Failed to fetch entitlements');
            }

            const data = await response.json();

            // Find a valid entitlement (mimic the legacy logic)
            const validEntitlement = data.content?.find((ent) => ent.state === 'allocated' || ent.state === 'in_use');

            if (validEntitlement) {
                setEntitlement(validEntitlement);
                return validEntitlement;
            } else {
                throw new Error('No valid entitlements found');
            }
        } catch (err) {
            console.error('Entitlement validation error:', err);
            setError(err.message);
            throw err;
        } finally {
            setIsValidating(false);
        }
    }, []);

    const resetEntitlement = useCallback(() => {
        setEntitlement(null);
        setError(null);
        setIsValidating(false);
    }, []);

    return {
        validateEntitlement,
        resetEntitlement,
        isValidating,
        entitlement,
        error,
    };
};
